import React from 'react';

/**
 * La ficha trazada: el gesto central de GeoVis Urbanismo. Una parcela señalada en un
 * plano de zonificación y su ficha, donde cada cifra lleva su cita (documento, artículo
 * y página). Los valores son un EJEMPLO ilustrativo; los colores son los de las
 * familias urbanísticas del producto, no decoración. El héroe de la home los usa en
 * components/home/MapaVivo.js.
 */

/* Manzanas del plano pequeño de /urbanismo (viewBox 320×260). */
const MANZANAS = [
  { x: 8, y: 8, an: 110, al: 70, familia: 'f-residencial' },
  { x: 124, y: 8, an: 76, al: 70, familia: 'f-dotacio' },
  { x: 204, y: 8, an: 108, al: 42, familia: 'f-sistema' },
  { x: 204, y: 54, an: 108, al: 24, familia: 'f-residencial' },
  { x: 8, y: 86, an: 64, al: 88, familia: 'f-activitat' },
  { x: 78, y: 86, an: 122, al: 54, familia: 'f-residencial' },
  { x: 78, y: 146, an: 122, al: 28, familia: 'f-sistema' },
  { x: 204, y: 86, an: 108, al: 88, familia: 'f-urbanitzable' },
  { x: 8, y: 182, an: 150, al: 70, familia: 'f-no-urbanitzable' },
  { x: 164, y: 182, an: 148, al: 70, familia: 'f-no-urbanitzable' },
];

export const PlanoZonificacion = () => (
  <svg
    viewBox="0 0 320 260"
    className="h-auto w-full"
    role="img"
    aria-label="Plano de zonificación urbanística con manzanas coloreadas por familia y una parcela señalada"
  >
    {/* Dentro de un contenedor [data-dibuja] las manzanas se colorean y la parcela se traza al verse. */}
    {MANZANAS.map((m, i) => (
      <g key={`${m.x}-${m.y}`}>
        <rect className="relleno" style={{ '--d': `${200 + i * 90}ms`, '--o': 0.55 }} x={m.x} y={m.y} width={m.an} height={m.al} rx="1.5" fill={`var(--${m.familia})`} />
        <rect className="trazo" style={{ '--d': `${i * 60}ms` }} pathLength="1000" x={m.x} y={m.y} width={m.an} height={m.al} rx="1.5" fill="none" stroke={`var(--${m.familia})`} strokeWidth="1" />
      </g>
    ))}
    {/* La parcela señalada: el gesto central del producto */}
    <rect className="trazo" style={{ '--d': '1100ms' }} pathLength="1000" x="78" y="86" width="122" height="54" rx="1.5" fill="none" stroke="oklch(var(--ember))" strokeWidth="2.5" />
    <line className="trazo" style={{ '--d': '1400ms' }} pathLength="1000" x1="200" y1="113" x2="252" y2="113" stroke="oklch(var(--ember))" strokeWidth="1.25" strokeDasharray="3 3" />
    <circle className="relleno" style={{ '--d': '1600ms' }} cx="256" cy="113" r="2.5" fill="oklch(var(--ember))" />
  </svg>
);

/* La ficha de ejemplo: cada cifra con su cita. Es el diferencial del producto. */
export const FICHA = [
  { campo: 'Clasificación', valor: 'Suelo urbano consolidado', fuente: 'PGOU · art. 42 · pág. 118' },
  { campo: 'Calificación', valor: 'Residencial · clave 13b', fuente: 'Plano O-3 · hoja 12' },
  { campo: 'Edificabilidad', valor: '1,20 m²t/m²s', fuente: 'Normas · art. 156.2 · pág. 301' },
  { campo: 'Altura máxima', valor: 'PB+3 · 13,50 m', fuente: 'Ordenanza clave 13b · pág. 304' },
  { campo: 'Ocupación', valor: '70 %', fuente: 'Ordenanza clave 13b · pág. 305' },
];
